import { takeLatest, call, put } from 'redux-saga/effects'
import {
    createRequestAPI, requestDetailAPI, requestListAPI,
    updateRequestStatusAPI
} from '../api-requests/request';
import {
    creatRequestReqError, creatRequestReqSuccess, requestDetailReqError,
    requestDetailReqSuccess, requestListReqError, requestListReqSuccess,
    updateRequestStatusReqError, updateRequestStatusReqSuccess
} from './request.action';
import { RequestActionTypes } from './request.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';

function* handleUpdateRequestStatus({ payload }) {
    try {
        const response = yield call(updateRequestStatusAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateRequestStatusReqSuccess(decryptedData))
            } else {
                yield put(updateRequestStatusReqError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(updateRequestStatusReqError(error.response.data))
    }
}

export function* updateRequestStatusReq() {
    yield takeLatest(RequestActionTypes.UPDATE_REQUEST_STATUS_REQ, handleUpdateRequestStatus)
}

function* handleRequestList({ payload }) {
    try {
        const response = yield call(requestListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(requestListReqSuccess(decryptedData))
            } else {
                yield put(requestListReqError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(requestListReqError(error.response.data))
    }
}

export function* requestListReq() {
    yield takeLatest(RequestActionTypes.REQUEST_LIST_REQ, handleRequestList)
}

function* handleRequestDetail({ payload }) {
    try {
        const response = yield call(requestDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(requestDetailReqSuccess(decryptedData))
            } else {
                yield put(requestDetailReqError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(requestDetailReqError(error.response.data))
    }
}

export function* requestDetailReq() {
    yield takeLatest(RequestActionTypes.REQUEST_DETAIL_REQ, handleRequestDetail)
}

function* handleCreateRequest({ payload }) {
    try {
        const response = yield call(createRequestAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(creatRequestReqSuccess(decryptedData))
            } else {
                yield put(creatRequestReqError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(creatRequestReqError(error.response.data))
    }
}

export function* createRequestReq() {
    yield takeLatest(RequestActionTypes.CREATE_REQUEST_REQ, handleCreateRequest)
}